@if (isLoading) {
  <div class="flex justify-center items-center py-12">
    <div
      class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"
    ></div>
    <span class="ml-3 text-gray-500 dark:text-gray-400 font-medium"
      >Cargando listas...</span
    >
  </div>
}

@if (error) {
  <div
    class="p-4 bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 rounded-xl border border-red-200 dark:border-red-800 flex items-center gap-3"
  >
    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      ></path>
    </svg>
    <p class="font-medium">{{ error }}</p>
  </div>
}

@if (!isLoading && !error) {
  @if (selectedIds.length > 0) {
    <div
      class="flex items-center gap-4 px-4 py-3 mb-3 bg-brand-50 dark:bg-brand-500/10 border border-brand-200 dark:border-brand-500/30 rounded-xl text-sm font-medium text-brand-700 dark:text-brand-300 flex-wrap"
    >
      <span>{{ selectedIds.length }} lista{{ selectedIds.length !== 1 ? 's' : '' }} seleccionada{{ selectedIds.length !== 1 ? 's' : '' }}</span>
      <div class="flex items-center gap-2 ml-auto">
        <button
          [appDisableWithoutPermission]="'segments:edit'"
          (click)="openMoveFolder.emit()"
          class="inline-flex items-center gap-1.5 px-3 py-1 text-xs font-medium bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 rounded-lg hover:border-brand-400 transition-colors"
        >
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"></path></svg>
          Mover a carpeta
        </button>
        <button
          [appDisableWithoutPermission]="'segments:delete'"
          (click)="bulkDelete.emit()"
          class="inline-flex items-center gap-1.5 px-3 py-1 text-xs font-medium bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-error-600 dark:text-error-400 rounded-lg hover:border-error-400 transition-colors"
        >
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
          Eliminar
        </button>
      </div>
    </div>
  }

  <div
    class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]"
  >
    <div class="max-w-full overflow-x-auto custom-scrollbar">
      <table class="min-w-full">
        <thead class="border-b border-gray-100 dark:border-white/[0.05]">
          <tr>
            <th class="w-10 px-4 py-3">
              <input
                type="checkbox"
                class="w-4 h-4 cursor-pointer accent-brand-500"
                [checked]="isAllSelected"
                (change)="toggleAll.emit($event)"
              />
            </th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Nombre / Carpeta</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Tipo</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Estado</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Objeto</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Miembros</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Actualización</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
          @if (segments.length === 0) {
            <tr>
              <td colspan="8" class="px-5 py-12 text-center">
                <div class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400">
                  <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                      d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 002-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                    ></path>
                  </svg>
                  <span>No se encontraron listas para los filtros actuales</span>
                </div>
              </td>
            </tr>
          }

          @for (segment of segments; track segment.id) {
            <tr
              [ngClass]="{
                'bg-brand-50/40 dark:bg-brand-500/5': isSelected(segment.id),
              }"
            >
              <td class="px-4 py-3" (click)="$event.stopPropagation()">
                <input
                  type="checkbox"
                  class="w-4 h-4 cursor-pointer accent-brand-500"
                  [checked]="isSelected(segment.id)"
                  (change)="toggleSelection.emit(segment.id)"
                />
              </td>
              <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                <div class="flex flex-col">
                  <span
                    class="font-medium text-gray-800 dark:text-white/90 cursor-pointer hover:text-brand-500"
                    (click)="view.emit(segment.id)"
                  >
                    {{ segment.name }}
                  </span>
                  @if (segment.folderName) {
                    <span
                      class="mt-1 flex w-max px-2 py-0.5 rounded-md text-[11px] font-medium bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400"
                    >
                      {{ segment.folderName }}
                    </span>
                  }
                </div>
              </td>
              <td class="px-4 py-3 text-start text-theme-sm whitespace-nowrap">
                <span
                  class="inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium"
                  [ngClass]="getTypeBadge(segment.type).color"
                >
                  {{ getTypeBadge(segment.type).text }}
                </span>
              </td>
              <td class="px-4 py-3 text-start text-theme-sm whitespace-nowrap">
                <span
                  class="inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium"
                  [ngClass]="getStatusBadge(segment.status).color"
                >
                  {{ getStatusBadge(segment.status).text }}
                </span>
              </td>
              <td
                class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400 whitespace-nowrap"
              >
                {{
                  segment.objectType === "CONTACT"
                    ? "Contactos"
                    : segment.objectType === "COMPANY"
                      ? "Empresas"
                      : segment.objectType
                }}
              </td>
              <td
                class="px-4 py-3 text-start text-theme-sm font-medium text-gray-800 dark:text-white/90 whitespace-nowrap"
              >
                {{ segment.totalContacts || 0 }}
              </td>
              <td
                class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400 whitespace-nowrap"
              >
                {{
                  formatDate(
                    segment.datetimeUpdated || segment.datetimeCreated || ""
                  )
                }}
              </td>
              <td class="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400 whitespace-nowrap" (click)="$event.stopPropagation()">
                <div class="flex items-center justify-center gap-1">
                  <button
                    [appDisableWithoutPermission]="'segments:edit'"
                    (click)="edit.emit(segment.id)"
                    class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors"
                    title="Editar"
                  >
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      ></path>
                    </svg>
                  </button>

                  <button
                    [appDisableWithoutPermission]="'segments:create'"
                    (click)="duplicate.emit(segment.id)"
                    class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors"
                    title="Duplicar"
                  >
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      ></path>
                    </svg>
                  </button>

                  <button
                    [appDisableWithoutPermission]="'segments:delete'"
                    (click)="delete.emit(segment.id)"
                    class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 dark:hover:bg-error-500/10 dark:hover:text-error-400 transition-colors"
                    title="Eliminar"
                  >
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      ></path>
                    </svg>
                  </button>

                  @if (segment.status === 'DRAFT') {
                  <button
                    [appDisableWithoutPermission]="'segments:edit'"
                    (click)="changeStatus.emit({ id: segment.id, newStatus: 'READY', action: 'activar' })"
                    class="rounded-lg p-2 hover:bg-emerald-50 hover:text-emerald-600 dark:hover:bg-emerald-500/10 dark:hover:text-emerald-400 transition-colors"
                    title="Activar"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </button>
                  }

                  @if (segment.status === 'READY') {
                  <button
                    [appDisableWithoutPermission]="'segments:edit'"
                    (click)="changeStatus.emit({ id: segment.id, newStatus: 'DRAFT', action: 'inactivar' })"
                    class="rounded-lg p-2 hover:bg-amber-50 hover:text-amber-600 dark:hover:bg-amber-500/10 dark:hover:text-amber-400 transition-colors"
                    title="Inactivar"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                  </button>
                  }

                  @if (segment.status !== 'ARCHIVED') {
                  <button
                    [appDisableWithoutPermission]="'segments:edit'"
                    (click)="changeStatus.emit({ id: segment.id, newStatus: 'ARCHIVED', action: 'archivar' })"
                    class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors"
                    title="Archivar"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"></path>
                    </svg>
                  </button>
                  }

                  @if (segment.status === 'ARCHIVED') {
                  <button
                    [appDisableWithoutPermission]="'segments:edit'"
                    (click)="changeStatus.emit({ id: segment.id, newStatus: 'DRAFT', action: 'restaurar' })"
                    class="rounded-lg p-2 hover:bg-brand-50 hover:text-brand-600 dark:hover:bg-brand-500/10 dark:hover:text-brand-400 transition-colors"
                    title="Restaurar"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                    </svg>
                  </button>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (totalPages >= 1) {
    <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 px-5 pb-4">
      <div class="flex items-center justify-between gap-4 flex-wrap">
        <div class="flex items-center gap-2">
          <span class="text-sm text-gray-500 dark:text-gray-400">{{ totalElements }} registros</span>
          <select [ngModel]="pageSize" (ngModelChange)="pageSizeChange.emit($event)"
            class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                   bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                   focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            @for (opt of pageSizeOptions; track opt) {
              <option [value]="opt">{{ opt }}</option>
            }
          </select>
        </div>
        <div class="flex items-center gap-2">
          <button type="button" (click)="prevPage.emit()" [disabled]="!hasPrevPage"
            class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                   bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                   hover:bg-gray-50 dark:hover:bg-gray-700
                   disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            Anterior
          </button>
          <div class="flex items-center gap-1.5">
            <span class="text-sm text-gray-500 dark:text-gray-400">Página</span>
            <select [ngModel]="pageDisplay" (ngModelChange)="onPageDisplayChange($event)"
              class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                     bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                     focus:ring-2 focus:ring-brand-500 focus:border-transparent">
              @for (p of pagesArray; track p) {
                <option [value]="p">{{ p }}</option>
              }
            </select>
            <span class="text-sm text-gray-500 dark:text-gray-400">de {{ totalPages }}</span>
          </div>
          <button type="button" (click)="nextPage.emit()" [disabled]="!hasNextPage"
            class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                   bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                   hover:bg-gray-50 dark:hover:bg-gray-700
                   disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            Siguiente
          </button>
        </div>
      </div>
    </div>
    }
  </div>
}
